/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./palantir-text.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./palantir-text.component";
var styles_PalantirTextComponent = [i0.styles];
var RenderType_PalantirTextComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_PalantirTextComponent, data: {} });
export { RenderType_PalantirTextComponent as RenderType_PalantirTextComponent };
export function View_PalantirTextComponent_0(_l) { return i1.ɵvid(2, [i1.ɵncd(null, 0)], null, null); }
export function View_PalantirTextComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "palantir-text", [], null, null, null, View_PalantirTextComponent_0, RenderType_PalantirTextComponent)), i1.ɵdid(1, 49152, null, 0, i2.PalantirTextComponent, [], null, null)], null, null); }
var PalantirTextComponentNgFactory = i1.ɵccf("palantir-text", i2.PalantirTextComponent, View_PalantirTextComponent_Host_0, { type: "type", size: "size", truncate: "truncate", italic: "italic" }, {}, ["*"]);
export { PalantirTextComponentNgFactory as PalantirTextComponentNgFactory };
